// extracted by mini-css-extract-plugin
module.exports = {"container":"-YC8W","socialActions":"ahXbT","buttonContainer":"_1hLsx","button":"_1K6AP","buttonWrapper":"_2j6Ak","likeCount":"ZzRUP"};